import icons from './lists/icons.svg'
import social from './lists/social.svg'
import './styles.scss'

interface IIcon {
  name: string
  list?: string
  width?: string
  height?: string
  stroke?: string
  fill?: string
  className?: string
  onClick?: () => void
}

interface ILists {
  [key: string]: string
}

const Icon = ({ name, list, onClick, className, stroke, fill , width, height }: IIcon) => {
  const lists: ILists = {
    icons,
    social,
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      className={`
        svg
        ${className}
        ${onClick ? 'c-pointer' : ''}
      `}
      width={width ?? '24'}
      height={height ?? '24'}
      onClick={onClick}
      stroke={stroke}
      fill={fill}
    >
      <use xlinkHref={`${lists[list || 'icons']}#${name}`} />
    </svg>
  )
}

export default Icon
